/** @jsxImportSource solid-js */
import { Button, PrimaryButton } from "#palette/components/button.solid";
import { globalState } from "#root/frontend/state";

export async function shouldShowPrivacyPolicyPage(): Promise<boolean> {
  return (
    !globalState.client.acceptedPrivacyPolicy ||
    !(globalState.client.userData.acceptedPrivacyPolicyApr2026 ?? false)
  );
}

export function AcceptPrivacyPolicyPage(props: { goNext: () => void }) {
  return (
    <>
      <h1 class="text-xl font-bold">
        We have updated our privacy policy and/or terms of service
      </h1>
      <p>
        By clicking "I accept" below you are indicating that you have read the{" "}
        <a
          href="https://www.projectcallisto.org/callisto-vault-privacy-policy"
          rel="noreferrer"
          class="underline"
          target="_blank"
        >
          Callisto Vault Privacy Policy
        </a>{" "}
        and{" "}
        <a
          href="https://www.projectcallisto.org/terms-of-service"
          rel="noreferrer"
          class="underline"
          target="_blank"
        >
          Callisto Vault Terms of Service
        </a>{" "}
        and you accept their terms.
      </p>
      <div class="flex items-center justify-between mt-4 gap-10">
        <Button
          onClick={() => {
            globalState.client.acceptedPrivacyPolicy = false;
            props.goNext();
          }}
        >
          I Decline
        </Button>
        <PrimaryButton
          onClick={async () => {
            await globalState.client.acceptPrivacyPolicy();
            props.goNext();
          }}
        >
          I Accept
        </PrimaryButton>
      </div>
    </>
  );
}
